import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider, App as AntApp } from 'antd';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';

// Temporarily disabled service worker due to caching issues
// import registerServiceWorker from './serviceWorkerRegistration';
// registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Disable refetch on window focus
      refetchOnReconnect: false, // Disable refetch on reconnect
      retry: 1, // Only retry once
      staleTime: 10 * 60 * 1000, // 10 minutes cache
      cacheTime: 10 * 60 * 1000, // 10 minutes cache
      refetchInterval: false, // Disable automatic refetch
      onError: (error) => {
        // Log errors but don't show toasts to prevent loops
        console.error('Query error:', error);
      },
    },
    mutations: {
      retry: 1,
      onError: (error) => {
        console.error('Mutation error:', error);
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#722ed1',
            borderRadius: 6,
            fontSize: 16,
          },
        }}
      >
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          basename={process.env.REACT_APP_BASENAME || '/'}
        >
          <AntApp>
            <App />
          </AntApp>
        </BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
